import { useState } from 'react';
import { Chip, Tab, Tabs } from '@nextui-org/react';
import ModalSlideFilter from '../../../../../common/src/components/filters/modal-sidebar-filter';
import { useTranslation } from 'common/src/hooks/useTranslation';
import { FiltersToggle, PageHeader, PageLayout } from '../../../components/ui';
import {
  FiltersPanel,
  ResumenTab,
  DestinosTab,
  SemanaTab,
  VariedadesTab,
  TramosTab,
  MethodologyGrid,
} from './sections';

type FrescuraView = 'resumen' | 'destino' | 'semana' | 'variedad' | 'tramos';

const FrescuraPage = () => {
  const { t } = useTranslation('common');
  const [view, setView] = useState<FrescuraView>('resumen');
  const [isFilterOpen, setIsFilterOpen] = useState(true);

  return (
    <div className='flex w-full h-screen overflow-x-hidden'>
      <ModalSlideFilter
        isOpen={isFilterOpen}
        onClose={() => setIsFilterOpen(false)}
      >
        <FiltersPanel />
      </ModalSlideFilter>

      <PageLayout className='overflow-y-auto'>
        <PageHeader
          title={t('Frescura')}
          description={t(
            'Cuánta vida útil consume tu cadena y cómo llega tu fruta vs. la industria'
          )}
          titleAddon={
            <Chip size='sm' variant='flat' color='warning'>
              {t('Demo · datos de ejemplo')}
            </Chip>
          }
        />

        <div className='flex justify-between items-center mb-4'>
          <FiltersToggle
            isOpen={isFilterOpen}
            onToggle={() => setIsFilterOpen(!isFilterOpen)}
            label={isFilterOpen ? t('Ocultar filtros') : t('Mostrar filtros')}
          />
        </div>

        <div className='overflow-x-auto mb-4'>
          <div className='min-w-[480px]'>
            <Tabs
              aria-label={t('Vista')}
              selectedKey={view}
              onSelectionChange={(key) => setView(key as FrescuraView)}
              size='lg'
              variant='underlined'
            >
              <Tab key='resumen' title={t('Resumen')} />
              <Tab key='destino' title={t('Por destino')} />
              <Tab key='semana' title={t('Por semana')} />
              <Tab key='variedad' title={t('Por variedad')} />
              <Tab key='tramos' title={t('Tramos y actores')} />
            </Tabs>
          </div>
        </div>

        {view === 'resumen' && <ResumenTab />}
        {view === 'destino' && <DestinosTab />}
        {view === 'semana' && <SemanaTab />}
        {view === 'variedad' && <VariedadesTab />}
        {view === 'tramos' && <TramosTab />}

        <MethodologyGrid />
        <div className='h-10' />
      </PageLayout>
    </div>
  );
};

export default FrescuraPage;
